import { createIntegrationRoute } from '../../route';
import { ApplicationEntrypointConfig } from '../../entrypoint';

export const INTEGRATION_ROUTE: ApplicationEntrypointConfig['route']['integration'] = {
    config: {},
    create: createIntegrationRoute,
};
